import type { IconDataInput } from '@appTypes';

// Devuelve un objeto de inputs para el componente de ícono, con todas las propiedades
export const getIconDataInput = (dataInput: IconDataInput): Required<Omit<IconDataInput, 'color' | 'size'>> & Pick<IconDataInput, 'color' | 'size'> => {
  return {
    icon: dataInput.icon,
    color: dataInput.color,
    size: dataInput.size ?? '20px',
    rotation: dataInput.rotation ?? 0,
    rotationDelay: dataInput.rotationDelay ?? 0,
    scale: dataInput.scale ?? 1,
    viewBoxAdjustmentX: dataInput.viewBoxAdjustmentX ?? 0,
    viewBoxAdjustmentY: dataInput.viewBoxAdjustmentY ?? 0,
  };
};
